
import { NTError, UnauthorizedError, ForbiddenError, NotFoundError } from '@nt-portal/server-sdk';
import { AzureAuthenticationError } from '../../types';



/**
 * Maps known SDK and authentication errors to readable messages.
 * @param ex Exception instance or error-like object to evaluate.
 * @returns Human-friendly description or a generic fallback.
 */
const resolveError = (ex: any): string => {

    let errorMsg: string = '';
    if(ex.hasOwnProperty('message')){
        console.log(ex.message)
        return ex.message
    }
    switch (ex) {
        case ex instanceof NTError:
            errorMsg = 'Unknown SDK Error.';
            break;
        case ex instanceof UnauthorizedError:
            errorMsg = 'Unauthorized for this action!';
            break;
        case ex instanceof ForbiddenError:
            errorMsg = 'Forbidden to do this action!';
            break;
        case ex instanceof NotFoundError:
            errorMsg = 'Resource not found.';
            break;
        case ex instanceof AzureAuthenticationError:
            errorMsg = 'Authentication Failed.';
            break;
        // case ex instanceof GeoLocationError:
        //     errorMsg = 'Failed to get Location.';
        //     break;
        default:
            errorMsg = 'Unknown Error occurred.'
            break;
    }
    return errorMsg
}

export default resolveError